/*
 * Mobile navigation controller.
 */
var NavControllerMobile = (function ($) {

    var body, mobileNav, toggleNav, touchEvent, utilityNav,
        animationTimeout = 600,
        speedyAnimationTimeout = 400,
        animationOffset = Math.floor(animationTimeout / 5);

    function ready() {
        body = $(document.body);
        toggleNav = $("a.toggle-nav");
        touchEvent = $("html").hasClass('touch') ? 'touchend' : 'click';
        utilityNav = $("nav[aria-label='Utility Navigation'] ul");

        toggleNav.on(touchEvent, toggleClick);
        if (touchEvent !== 'click') {
            toggleNav.on('click', function (e) { e.preventDefault() });
        }

        mobileNav = $("nav.mobile");
        mobileNav.on('click', '.subnav .forward', onSubnavOpenClick);
        mobileNav.on('click', '.subnav .back a', onSubnavBackClick);
        mobileNav.on('click', '.close', onCloseClick);

        $(BreakpointController).on('crossBreakpoint', onCrossBreakpoint);
        $(OverlayController).on('overlayClick', onCloseClick);

        body.on('focusin', '*', function (e) {
            if (mobileNav.css('display') != 'block') {
                return;
            }
            if (isMobileNavDescendant(e.currentTarget)) {
                return;
            }
            closeNav();
        });
        //console.log('bound');
    }

    // Close the whole menu.
    function onCloseClick(e) {
        e.preventDefault();
        closeNav();
    }

    // Close the current subnav allowing the parent underneath to be displayed again.
    function onSubnavBackClick(e) {
        e.preventDefault();
        var clicked = $(e.target),
            subnav = clicked.closest('ul');

        closeNav({ nextNav: subnav, isSubnav: true });
        subnav.siblings("a.forward").focus();
    }

    // On click of a subnav's chevron open the next level.
    function onSubnavOpenClick(e) {
        e.preventDefault();

        var clicked = $(e.target);
        if (!clicked.is("a")) {
            clicked = clicked.closest('a');
        }

        openNav({ nextNav: clicked.next('ul') });
    }

    // When crossing breakpoints, close the nav if it's open.
    function onCrossBreakpoint(e) {
        quickCloseNav();
    }

    // On click of the toggle nav link / button.
    function toggleClick(e) {
        e.preventDefault();

        if (body.hasClass("nav-opening") || body.hasClass('nav-open')) {
            SearchController.blur();
            SearchController.clear();
            closeNav({ isSubnav: false });
        }
        else {
            openNav({ animateBody: true });
        }
    }

    function openNav(options) {
        options = options || {};
        var nextNav = options.nextNav || mobileNav;
        var animateBody = !!options.animateBody;
        OverlayController.show();

        if (animateBody) {
            body.addClass('nav-opening');
        }

        nextNav.css({ display: 'block', right: '-100%' });
        nextNav.stop(true, false).animate({ right: '-0%' }, animationTimeout, 'easeOutQuart', function () {
            body.addClass('nav-open').removeClass('nav-opening nav-closing');
        });

        utilityNav.find("li a").each(function () {
            $(this).attr("aria-hidden", "true").attr('tabindex', "-1");
        });

        if (!!options.nextNav) {
            //subnav
            $(nextNav).find("li a").each(function () {
                $(this).attr('tabindex', "0");
            });
        } else {
            //primarynav
            $("li.subnav").find("ul li a").each(function () {
                $(this).attr('tabindex', "-1");
            });
        }
    }

    function closeNav(options) {
        options = options || {};
        var nextNav = options.nextNav || mobileNav;
        var isSubnav = !!options.isSubnav;
        var animateBody = !isSubnav;

        // Close the children first if there are any
        var children = nextNav.find("li.subnav > ul:visible");

        if (animateBody) {
            body.removeClass('nav-opening').addClass('nav-closing');
        }

        nextNav.add(children).stop(true, false).animate({ right: '-100%' }, speedyAnimationTimeout - animationOffset, 'easeOutQuart', function () {
            if (!isSubnav) {
                body.removeClass('nav-open nav-opening nav-closing');
                OverlayController.hide();
                //Primarynav
                utilityNav.find("li a").each(function () {
                    $(this).attr("aria-hidden", "false").attr('tabindex', "0");
                });
            } else {
                $(nextNav).find("li a").each(function () {
                    $(this).attr('tabindex', "-1");
                });
            }

            nextNav.attr('style', '');
        });
    }

    function quickCloseNav(options) {
        options = options || {};
        const nextNav = options.nextNav || mobileNav;
        nextNav.add(nextNav.find('.subnav > ul')).attr('style', '');
        body.removeClass('nav-open nav-opening');
    }

    function isMobileNavDescendant(el) {
        if (el == mobileNav[0]) {
            //console.log('true');
            return true;
        }
        var parent = $(el).parent();
        if (!parent || parent.length < 1) {
            //console.log('false');
            return false;
        }
        return isMobileNavDescendant(parent[0]);
    }

    $(ready);

})(jQuery);